import React from 'react'

import { IStrapiButton, IStrapiLinkButton } from '~/types/strapi'

import type { ButtonProperties } from '../types'
import VariantButton from '../variant'

interface BaseProperties {
  attributes: IStrapiLinkButton | IStrapiButton
  tiny?: boolean
}

type Properties = BaseProperties & Partial<ButtonProperties>

const CMSButton: React.FC<Properties> = ({ attributes, tiny, ...rest }) => {
  if (!attributes) return

  if ('url' in attributes) {
    return (
      <VariantButton
        {...(rest as React.AnchorHTMLAttributes<HTMLAnchorElement>)}
        component="link"
        blank={attributes.blank}
        variant={attributes.variant}
        text={attributes.text}
        textMobile={attributes.textMobile}
        href={attributes.url}
        openContactModal={attributes.contactModalOnClick}
        tiny={tiny}
      />
    )
  }

  return (
    <VariantButton
      type="button"
      {...(rest as React.ButtonHTMLAttributes<HTMLButtonElement>)}
      component="button"
      variant={attributes.variant}
      text={attributes.text}
      textMobile={attributes.textMobile}
      openContactModal={attributes.contactModalOnClick}
      tiny={tiny}
    />
  )
}

export default CMSButton
